import { AdKind } from '@/api/types/common.types';
import { BulkPromotionServiceType } from '@/features/Profile/sections/MyAds/api';

export const AD_KIND_BY_SERVICE_TYPE: Record<BulkPromotionServiceType, AdKind> =
  {
    [BulkPromotionServiceType.BUMP]: AdKind.Bumped,
    [BulkPromotionServiceType.VIP]: AdKind.Vipped,
    [BulkPromotionServiceType.FEATURE]: AdKind.Premium,
  };
